export default {
	projectList: [],
    projectStatusList: [],
    projectSpecifiers: [],
    projectVehicles: [],
    projectImages: [],
    objProjectStatusEdit: [],
    projectRegions: [],
	projectRegionTypes: [],
	projectRegionSub: [],
	projectRegionTown: [],
	objProjectEdit: [],
	projectPreLocations: [],
	projectEditImages: [],
    projectTenderWinner: [],
  selectedNewLeadProject: ''
}
